<template>
  <PCSettingsBlock :title="t('userConfiguration.informationBar.title')">
    <PCSettingsBlockItem :title="t('userConfiguration.informationBar.show.title')">
      <template #right>
        <f7-toggle
          :checked="showInformationBar"
          @toggle:change="showInformationBar = $event"
        />
      </template>
    </PCSettingsBlockItem>

    <PCSettingsBlock
      v-show="showInformationBar"
      is-sortable
      :title="t('userConfiguration.informationBar.order.title')"
      class="padding-left"
      @sortable:sort="sortInformationElements"
    >
      <PCSettingsBlockItem
        v-for="(item) in informationBarItems"
        :key="item.key"
        :title="t(`${item.title}`)"
        is-sortable
      >
        <template #right>
          <f7-toggle
            :checked="!!informationBarRefs[item.key]"
            @toggle:change="informationBarRefs[item.key].value = $event"
          />
        </template>
      </PCSettingsBlockItem>
    </PCSettingsBlock>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { onMounted, ref } from 'vue';
import { useInformationBar } from '@/composables/useInformationBar';
import { useI18n } from 'vue-i18n';
import { useSettingRef } from '@erpagroapp/settings';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

/** @import { Ref } from 'vue' */
/** @import { InformationBarItem } from '@/composables/useInformationBar' */

/** @type {Ref<InformationBarItem[]>} */
const informationBarItems = ref([]);

const { t } = useI18n();

const {
  configurableItems,
  informationBarRefs,
} = useInformationBar();

const showInformationBar = useSettingRef('BarraInformacion.MostrarBarra');
const informationBarOrder = useSettingRef('BarraInformacion.OrdenElementos');

/**
 * Sorts the information bar elements.
 *
 * @param {Record<string, any>} detail - The sortable sort event detail.
 * @returns {void}
 */
function sortInformationElements(detail) {
  if ('from' in detail && 'to' in detail) {
    const { from, to } = detail;

    if (typeof from === 'number' && typeof to === 'number') {
      const newOrder = [...informationBarOrder.value];
      const [removedElement] = newOrder.splice(from, 1);

      if (removedElement) {
        newOrder.splice(to, 0, removedElement);
        informationBarOrder.value = newOrder;
      }
    }
  }
}

function handleInformationBarSettings() {
  informationBarItems.value = configurableItems.value
    .map(
      (item) => ({
        title: item.title,
        key: item.key,
        settingName: item.settingName,
      }),
    );

  const informationBarOrderTemp = informationBarOrder.value || [];
  if (informationBarOrderTemp) {
    informationBarItems.value = informationBarOrderTemp
      .map((key) => informationBarItems.value.find((item) => item.key === key))
      .filter((item) => typeof item !== 'undefined');
  }
}

onMounted(() => {
  handleInformationBarSettings();
});
</script>
